import styled from "styled-components";

export const Container = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const CityInfo = styled.div`
    display: flex;
    padding-top: 5px;
    flex-direction: column;
`;

export const LeftHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
